import { ForgotPasswordLayout } from '@components/Layouts/ForgotPassword'
import useCmxToast from '@hooks/useCmxToast'
import { firebaseClientInitConfig } from '@lib/firebase/config'
import { useUser } from '@lib/firebase/provider'
import tenantManager from '@lib/firebase/tenantManager'
import { createFileRoute } from '@tanstack/react-router'
import { AuthErrorCodes } from 'firebase/auth'

const TENANT = firebaseClientInitConfig.tenantIds.endUser

export const ForgotPassword = () => {
  const toast = useCmxToast()
  const { sendResetPassword } = useUser()

  const onSubmit = async (values) => {
    await tenantManager.setTenantId(TENANT)
    try {
      sendResetPassword(values.email)
    } catch (error) {
      if (error.code !== AuthErrorCodes.USER_DELETED) {
        toast({
          title: 'Unable to send reset password email',
          status: 'error',
        })
        return false
      }
    }
    return true
  }

  return <ForgotPasswordLayout onSubmit={onSubmit} />
}

export const Route = createFileRoute('/forgotPassword')({
  component: ForgotPassword,
})
